import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const PUBLIC_ROUTES = [
  // "/",
  "/login",
  "/signup",
  "/plan",
  "/buildyourprofile",
  "/services",
  "/resources",
  "/globall-pass",
  "/team",
  "/contactus",
  "/blog",
  "/ballerpreneurs",
  "/blog/:id",
  "/faq",
  "/privacypolicy",
  "/terms&conditions",
  "/thankswall",
];

const AuthWatcher = () => {
  const token = useSelector((state) => state?.auth?.user?.token);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
   if (!token && !PUBLIC_ROUTES.includes(location.pathname)) {
    
  let intendedUserType = null;
  if (location.pathname.startsWith("/business")) {
    intendedUserType = "Business";
  } else if (location.pathname.startsWith("/athlete")) {
    intendedUserType = "Athlete";
  } else if (location.pathname.startsWith("/contractor")) {
    intendedUserType = "Contractor";
  }

  localStorage.setItem("redirectData", JSON.stringify({
    path: location.pathname,
    userType: intendedUserType,
  }));

  navigate("/login");
}
  }, [token, navigate, location.pathname]);

  return null;
};

export default AuthWatcher;
